export default __webpack_public_path__ + "static/media/logo-fisheye.92a2e65c.svg";